export default {
  de: {
    title: 'Farben',
    description: '',
    backgroundColor: 'Hintergrundfarbe',
    color: 'Schriftfarbe',
    opacity: 'Deckkraft (0 - 100)',
  },
};
